import React, { useEffect, useState, useRef } from "react";
import "./PracticePhotos.scss";
import photostoavoid from "../../../assets/images/photos-to-avoid.jpg";
import uploadsamplefull from "../../../assets/images/upload-sample-full.jpg";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAddPracticePhotosWithoutProviders,
  fetchAddPracticePhotosWithProviders,
  fetchDeletePhotoFromCurrentLocation,
  fetchDeletePhotosFromAllLocation,
  fetchPracticePhotos,
  fetchPracticeProvidersName,
  fetchUpdateImageInformation,
} from "../../../store/PracticeInfo/PracticePhotosActions";
import { updatePracticePhotosList } from "../../../store/PracticeInfo/PracticePhotosReducer";
import PopupModal from "../../../common/PopupModal";
import ImageUpload from "../../../common/ImageUpload";
import imagePlaceholder from "../../../assets/images/ic-photo-upload.svg";
import CgCheckbox from "../../../common/CgCheckbox";
import { fetchProviderInformation } from "../../../store/ProviderInfo/ProviderOverviewActions";
import { generateDisplayId } from "../../../utils/commonUtilities";
import { useLocation } from "react-router-dom";

const PracticePhotos = ({
  onlyPopup = false,
  openPracticePopup,
  closePhotosPopupCallback = () => {},
}) => {
  const [openPopup, setOpenPopup] = useState(false);
  const [onlyPhotosPopup, setOpenOnlyPopup] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [confirmPhotoDelete, setConfirmPhotoDelete] = useState(false);
  const [deleteLocation, setDeleteLocation] = useState(null);
  const [showMsg, setShowMsg] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [resetImgValue, setResetImgValue] = useState(false);
  const [openSecondPopup, setOpenSecondPopup] = useState(false);
  const [uploadedImage, setUploadedImage] = useState([]);
  const [popupStep, setPopupStep] = useState(1);
  const [isProviderTagged, setIsProviderTagged] = useState(false);
  const [editPhotoPopup, setEditPhotoPopup] = useState(false);
  const [editingPhotoItem, setEditingPhotoItem] = useState(null);
  const [providersNameList, setProvidersNameList] = useState([]);
  const [rawUploadedFile, setRawUploadedFile] = useState([]);
  const [showError, setShowError] = useState(false);
  const [photoProviderSelections, setPhotoProviderSelections] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [checkboxStates, setCheckboxStates] = useState({});
  const [resetTrigger, setResetTrigger] = useState({});
  const dropDownRef = useRef(null);
  const dispatch = useDispatch();

  const {
    practicePhotosData,
    practicePhotosError,
    practiceProvidersNameData,
    isPracticePhotosLoading,
  } = useSelector((state) => state.practicePhotos);

  const gratePhotos = {
    header: "Examples of great photos",
    photo: uploadsamplefull,
    tipsList: [
      "Individual provider photos/headshots",
      "Smiling providers with friendly staff",
      "Inviting waiting room",
      "Clean & bright operatory",
    ],
  };

  const avoidPhotos = {
    header: "Examples of photos to avoid",
    photo: photostoavoid,
    tipsList: [
      "Photos of teeth/mouths",
      "Photos of patients",
      "Poorly lit photos of office/operatory",
      "Office logos or business cards",
    ],
  };

  const location = useLocation();
  const locationData = location.pathname.split("/");
  const practiceId = locationData[2];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    console.log(isProviderTagged);
    if (onlyPopup && practicePhotosData.length < 1) {
      // setPopupStep(1);
      setOpenOnlyPopup(false);
      setOpenPopup(true);
    }
  }, []);

  useEffect(() => {
    if (practicePhotosError) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [practicePhotosError]);

  useEffect(() => {
    console.log({ rawUploadedFile });
  }, [rawUploadedFile]);

  useEffect(() => {
    if (Array.isArray(practiceProvidersNameData)) {
      const updatedData = practiceProvidersNameData?.map((item) => {
        return {
          displayId: item?.displayId,
          name: `${item?.firstName} ${item?.lastName}`,
          code: `${item?.firstName} ${item?.lastName}`,
        };
      });
      setProvidersNameList(updatedData);
    } else {
      setProvidersNameList([]);
    }
  }, [practiceProvidersNameData]);

  useEffect(() => {
    dispatch(fetchPracticePhotos(practiceId));
    dispatch(fetchPracticeProvidersName(practiceId));
  }, [dispatch, practiceId]);

  useEffect(() => {
    setOpenOnlyPopup(openPracticePopup);
  }, [openPracticePopup]);

  const handleUpdatePhoto = () => {
    dispatch(
      fetchUpdateImageInformation({
        practiceId: practiceId,
        imageId: editingPhotoItem.displayId,
        data: {
          providerDisplayIds: [],
        },
      })
    ).then(() => {
      dispatch(fetchPracticePhotos(practiceId));
    });
    setEditPhotoPopup(!editPhotoPopup);
  };

  const handleResetEverything = () => {
    setOpenPopup(false);
    setOpenSecondPopup(false);
    setUploadedImage([]);
    setOpenSecondPopup(!openSecondPopup);
    setPopupStep(1);
    setPhotoProviderSelections({});
    setValidationErrors({});
    setCheckboxStates({});
    setResetTrigger({});
    setRawUploadedFile([]);
  };

  const handleDeleteUploadedImg = (img) => {
    const result = uploadedImage.filter((item) => item !== img);
    setUploadedImage(result);
  };

  const handleOnDeletePhoto = () => {
    const updatedData = practicePhotosData?.filter(
      (item) => item.displayId !== editItem
    );
    dispatch(updatePracticePhotosList(updatedData));
    setShowConfirmModal(!showConfirmModal);
    setConfirmPhotoDelete(!confirmPhotoDelete);
    if (deleteLocation !== "all") {
      dispatch(
        fetchDeletePhotoFromCurrentLocation({
          practiceId: practiceId,
          imageId: editItem,
        })
      ).then(() => {
        dispatch(fetchPracticePhotos(practiceId));
        setShowMsg("Photo deleted successfully from current location!");
      });
    } else {
      dispatch(
        fetchDeletePhotosFromAllLocation({
          practiceId: practiceId,
          imageId: editItem,
        })
      ).then(() => {
        dispatch(fetchPracticePhotos(practiceId));
        setShowMsg("Photo deleted successfully from all location!");
      });
    }
    setTimeout(() => {
      setShowMsg(null);
    }, [1000]);
  };

  const handleMouseEnter = (item) => {
    setHoveredItem(item);
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handlePencilClick = (displayId) => {
    setEditItem(displayId);
    setIsDropdownVisible(true);
  };

  const validatePhotoSelections = () => {
    const errors = {};
    rawUploadedFile.forEach((item) => {
      const selections = photoProviderSelections[item.displayId];
      if (!selections || selections.length === 0) {
        errors[item.displayId] = "Please make a selection for this photo.";
      }
    });
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSavePhotos = () => {
    if (!validatePhotoSelections()) {
      return;
    }

    rawUploadedFile.map((item) => {
      const formData = new FormData();
      formData.append("file", item.data);

      const providerSelections = photoProviderSelections[item.displayId] || [];

      const providerIds = providerSelections
        .filter(
          (selection) =>
            selection !== "There are no providers in this photo" &&
            selection !== "This is a Google street view photo"
        )
        .map((selection) => {
          const provider = providersNameList.find((p) => p.code === selection);
          return provider?.displayId;
        })
        .filter(Boolean);

      if (providerIds.length > 0) {
        dispatch(
          fetchAddPracticePhotosWithProviders({
            practiceId: practiceId,
            providerId: providerIds[0],
            data: formData,
          })
        ).then(() => {
          dispatch(fetchPracticePhotos(practiceId));
        });
      } else {
        dispatch(
          fetchAddPracticePhotosWithoutProviders({
            practiceId: practiceId,
            data: formData,
          })
        ).then(() => {
          dispatch(fetchPracticePhotos(practiceId));
        });
      }
    });
    setOpenSecondPopup(false);
    handleResetEverything();
    closePhotosPopupCallback();
    setPopupStep(1);
  };

  const RenderUploadImageJsx = () => {
    return (
      <div className="imgUplodWrapper">
        <div className="imgUpload">
          <div className="imgFirstContentBlock">
            <img src={imagePlaceholder} alt="" height="50px" width="50px" />
            <div className="textCenter">
              Simply drag your images here or
              <span className="brosweLinkColor"> browse </span>
            </div>
          </div>
          <div className="inputFieldText">
            <div className="photosInstructionDesc">
              (We recommend 5-10 photos of your practice including office, staff
              and providers)
            </div>
            <p className="photosInstructionDesc">
              Supported file types: .png, .gif, .jpg, .jpeg
            </p>
          </div>
        </div>
      </div>
    );
  };

  const RenderUploadedPhotosList = () => {
    return (
      <div className="uploadedImagesListWrapper">
        {uploadedImage?.map((item, index) => {
          return (
            <div key={index} className="uploadedImageItem">
              <button
                type="submit"
                className="deleteUploadedImg"
                onClick={() => {
                  handleDeleteUploadedImg(item);
                }}
              >
                x
              </button>
              <div className="thumbNail">
                <img
                  alt=""
                  src={item}
                  height="150px"
                  width="150px"
                  style={{ objectFit: "contain" }}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const RenderAddPopupStatusBar = () => {
    return (
      <div className="imageUploadStatusBar">
        <ul>
          <li className="currentStepIndicator">
            <span
              className={`${popupStep == 1 ? "circle inProgress" : ""} ${
                popupStep == 2 ? "circle completed" : ""
              } `}
            ></span>
            <label
              className={`${popupStep == 1 ? "active" : ""} ${
                popupStep == 2 ? "done" : ""
              }`}
            >
              1. Upload Photos
            </label>
          </li>
          <li className="currentStepIndicator">
            <span
              className={`${popupStep == 1 ? "circle" : ""} ${
                popupStep == 2 ? "circle inProgress" : ""
              } `}
            ></span>
            <label className={`${popupStep == 2 ? "active" : ""}`}>
              2. Tag Providers
            </label>
          </li>
          <li className="currentStepIndicator">
            <span className={`circle`}></span>
            <label className={`${popupStep == 3 ? "active" : ""}`}>
              3. Choose Profile Photos
            </label>
          </li>
        </ul>
      </div>
    );
  };

  const RenderAddorUploadPhotos = () => {
    return (
      <div>
        <div>{RenderAddPopupStatusBar()}</div>
        <div>
          <div>
            <div className="uploadPhotoHeader">Upload Photos</div>
            <div className="uploadPhotosDesc">
              Highlight your practice and attract new patients with great
              photos.
            </div>
          </div>
          <div className="imageUploaderContentWrapper">
            <div className="practice-photo-imgUploadLeft">
              <ImageUpload
                resetValue={resetImgValue}
                renderCustom={RenderUploadImageJsx}
                isRenderCustom
                needCrop={false}
                uploadedImage={""}
                handleGetFormData={(res) => {
                  const updatedData = [...rawUploadedFile];
                  const data = {
                    displayId: generateDisplayId(),
                    data: res,
                  };
                  updatedData.push(data);
                  setRawUploadedFile(updatedData);
                }}
                fileUploaded={(res) => {
                  const updatedImage = [...uploadedImage];
                  updatedImage.push(res);
                  setUploadedImage(updatedImage);
                  setResetImgValue(true);
                }}
              />
              {RenderUploadedPhotosList()}
            </div>
            <div className="imgUploadRightPractice">{RenderPhotoTips()}</div>
          </div>
        </div>
        <div className="ImgPopupButtonsWrapper">
          <div
            className="cancelBtn"
            onClick={() => {
              // setOpenPopup(!openPopup);
              handleResetEverything();
              closePhotosPopupCallback();
            }}
          >
            CANCEL
          </div>
          {uploadedImage?.length > 0 && (
            <div
              className="saveBtn"
              onClick={() => {
                setOpenPopup(!openPopup);
                setPopupStep(2);
                setOpenSecondPopup(true);
                // if required we can enable the below line by commenting above line
                // setTimeout(() => {
                //   setOpenSecondPopup(true);
                // }, [1000]);
              }}
            >
              Next
            </div>
          )}
        </div>
      </div>
    );
  };

  const RenderSecondStepPopup = () => {
    return (
      <div className="renderSecondStepPopup">
        <div>
          <div>{RenderAddPopupStatusBar()}</div>
        </div>
        <div>
          {uploadedImage?.map((item, index) => {
            return (
              <div key={index} className="secondStepImageItem">
                <div>
                  <img
                    alt=""
                    src={item}
                    height="180px"
                    width="269px"
                    style={{ objectFit: "contain" }}
                    className="secondStepImgListItem"
                  />
                </div>
                <div className="imageContent">
                  <div
                    className="uploadPhotosDescPractice"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    CHECK BOXES FOR ALL PROVIDERS IN THIS PHOTO
                    {validationErrors[rawUploadedFile[index]?.displayId] && (
                      <p className="validation-error">
                        <span className="glyphicon glyphicon-exclamation-sign"></span>
                        {validationErrors[rawUploadedFile[index]?.displayId]}
                      </p>
                    )}
                  </div>
                  <div className="firstCheckboxWrapper">
                    <CgCheckbox
                      shouldRenderCheckboxWithBackgroundImageStyle={true}
                      key={`providers-${index}-${
                        checkboxStates[
                          `${rawUploadedFile[index]?.displayId}-providers`
                        ]?.length || 0
                      }`}
                      customLabel={false}
                      options={providersNameList}
                      keyValues={{ label: "name", value: "code" }}
                      defaultValues={
                        checkboxStates[
                          `${rawUploadedFile[index]?.displayId}-providers`
                        ] || []
                      }
                      resetValue={
                        resetTrigger[
                          `${rawUploadedFile[index]?.displayId}-providers`
                        ] || false
                      }
                      onSelect={(selected) => {
                        const photoId = rawUploadedFile[index]?.displayId;

                        const newCheckboxStates = { ...checkboxStates };
                        newCheckboxStates[`${photoId}-providers`] = selected;

                        if (selected?.length > 0) {
                          newCheckboxStates[`${photoId}-options`] = [];
                        }

                        setCheckboxStates(newCheckboxStates);

                        const currentSelections = {
                          ...photoProviderSelections,
                        };
                        currentSelections[photoId] = selected;
                        setPhotoProviderSelections(currentSelections);

                        if (selected?.length > 0) {
                          const newErrors = { ...validationErrors };
                          delete newErrors[photoId];
                          setValidationErrors(newErrors);
                        }

                        if (selected?.length > 0) {
                          setIsProviderTagged(true);
                        } else {
                          setIsProviderTagged(false);
                        }
                      }}
                    />
                  </div>
                  <div className="secondCheckboxWrapper">
                    <CgCheckbox
                      shouldRenderCheckboxWithBackgroundImageStyle={true}
                      key={`options-${index}-${
                        checkboxStates[
                          `${rawUploadedFile[index]?.displayId}-options`
                        ]?.length || 0
                      }`}
                      customLabel={false}
                      options={[
                        {
                          displayId: "VVQDEUSG57632222",
                          name: "There are no providers in this photo",
                          code: "There are no providers in this photo",
                        },
                        {
                          displayId: "VVQDEUSG57632211",
                          name: "This is a Google street view photo",
                          code: "This is a Google street view photo",
                        },
                      ]}
                      defaultValues={
                        checkboxStates[
                          `${rawUploadedFile[index]?.displayId}-options`
                        ] || []
                      }
                      keyValues={{ label: "name", value: "code" }}
                      resetValue={
                        resetTrigger[
                          `${rawUploadedFile[index]?.displayId}-options`
                        ] || false
                      }
                      onSelect={(selected) => {
                        const photoId = rawUploadedFile[index]?.displayId;

                        const newCheckboxStates = { ...checkboxStates };
                        newCheckboxStates[`${photoId}-options`] = selected;

                        if (selected?.length > 0) {
                          newCheckboxStates[`${photoId}-providers`] = [];
                        }

                        setCheckboxStates(newCheckboxStates);

                        const currentSelections = {
                          ...photoProviderSelections,
                        };
                        currentSelections[photoId] = selected;
                        setPhotoProviderSelections(currentSelections);

                        if (selected?.length > 0) {
                          const newErrors = { ...validationErrors };
                          delete newErrors[photoId];
                          setValidationErrors(newErrors);
                        }

                        setIsProviderTagged(false);
                      }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="popupButtonsWrapper">
          <div
            className="saveBtn"
            onClick={() => {
              // setOpenSecondPopup(false);
              // setPopupStep(1);
              // const newData = transformImageUrls(
              //   uploadedImage,
              //   "WIZVPWMN52560172",
              //   providerData?.firstName,
              //   providerData?.lastName
              // );
              // const updatedValues = [...practicePhotosData, ...newData];
              // dispatch(updatePracticePhotosList(updatedValues));
              // handleResetEverything();
              // closePhotosPopupCallback();
              handleSavePhotos();
            }}
          >
            Save
          </div>
          <div
            className="cancelBtn"
            onClick={() => {
              handleResetEverything();
              closePhotosPopupCallback();
            }}
          >
            CANCEL
          </div>
        </div>
      </div>
    );
  };

  const RenderEditPhotoContent = () => {
    const checkboxData = [...providersNameList];
    checkboxData.push({
      displayId: "VVQDEUSG57632224",
      name: "There are no providers in this photo",
      code: "There are no providers in this photo",
    });

    return (
      <div className="editPhotoWrapper">
        <div className="editPhotoHeader">Update Provider Tags</div>
        <hr />
        <div className="editPhotoContent">
          <div>
            <img
              alt=""
              src={editingPhotoItem?.image?.small}
              height="175px"
              width="175px"
            />
          </div>
          <div className="editPhotoContentItem2">
            <div className="editPhotoDesc">
              Check boxes for all providers in this photo
            </div>
            <div className="editPhotoCheckboxItem">
              <CgCheckbox
                shouldRenderCheckboxWithBackgroundImageStyle={true}
                customLabel={false}
                options={checkboxData}
                keyValues={{ label: "name", value: "code" }}
                defaultValues={[
                  `${editingPhotoItem?.taggedProviders?.firstName} ${editingPhotoItem?.taggedProviders?.lastName}`,
                ]}
                onSelect={(selected) => {
                  if (selected?.length > 0) {
                    setIsProviderTagged(true);
                  } else {
                    setIsProviderTagged(false);
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const RenderEditPhotoPopup = () => {
    return (
      <PopupModal
        width="83%"
        isOpen={editPhotoPopup}
        onClose={() => {
          setEditPhotoPopup(!editPhotoPopup);
          closePhotosPopupCallback();
        }}
        onSave={() => {
          handleUpdatePhoto();
        }}
        enableSave
        customRender={RenderEditPhotoContent}
      />
    );
  };

  const RenderPhotosPopupTwo = () => {
    if (popupStep !== 2) return null;
    return (
      <PopupModal
        width="83%"
        isOpen={openSecondPopup}
        onClose={() => {
          setOpenSecondPopup(!openSecondPopup);
          closePhotosPopupCallback();
          setRawUploadedFile([]);
        }}
        enableSave={false}
        customRender={RenderSecondStepPopup}
        // popupHeading="Add languages"
      />
    );
  };

  const RenderPhotosPopupOne = () => {
    if (popupStep !== 1) return null;
    return (
      <PopupModal
        width="83%"
        isOpen={openPopup}
        onClose={() => {
          closePhotosPopupCallback();
          setOpenPopup(!openPopup);
          setRawUploadedFile([]);
        }}
        enableSave={false}
        customRender={RenderAddorUploadPhotos}
        // popupHeading="Add languages"
      />
    );
  };

  const RenderPracticePhotosHeader = () => {
    return (
      <div className="practicePhotosHeaderWrapper">
        <div className="practicePhotosHeader">
          {/* <span> */}
          Photos of your practice
          {/* </span> */}
          <div
            className="photosAddBtn"
            onClick={() => {
              dispatch(fetchPracticeProvidersName(practiceId));
              setOpenPopup(!openPopup);
            }}
          >
            +ADD
          </div>
        </div>
        <div className="practicePhotosDesc">
          Give patients a view of your practice by uploading photos of operatory
          rooms, front desk, staff, and amenities.
        </div>
      </div>
    );
  };

  const RenderOnlyPopupPracticePhotosHeader = () => {
    return (
      <div className="onlyPopupHeaderWrapper">
        <div>
          <div className="newHeaderMain">
            Carson City Pediatric Dentistry LLC ({practicePhotosData?.length}{" "}
            {practicePhotosData?.length === 1 ? "photo" : "photos"})
          </div>
          <div className="newPopupPhotodesc">
            Brighter recommends 5-10 photos
          </div>
        </div>
        <div>
          <div
            className="saveBtn"
            onClick={() => {
              setOpenOnlyPopup(false);
              setOpenPopup(true);
            }}
          >
            Upload Photos
          </div>
        </div>
      </div>
    );
  };

  const RenderPhotosItem = (data) => {
    const { header, photo, tipsList } = data;
    return (
      <div className="practicePhtoTipsWrapper">
        <div className="profileDesc"> {header} </div>
        <div className="guidelinesPhotosWrapper">
          <img alt="" height="50px" width="200px" src={photo} />
        </div>
        <div className="practicePhotoGuideLinesWrapper">
          {tipsList.map((item, index) => {
            return (
              <div className="guideLinesItem" key={index}>{`- ${item}`}</div>
            );
          })}
        </div>
      </div>
    );
  };

  const RenderPhotoTips = () => {
    return (
      <div className="">
        <div className="profileHeader">
          <span> PHOTO TIPS </span>
          <div className="hrLine" />
        </div>
        {RenderPhotosItem(gratePhotos)}
        {RenderPhotosItem(avoidPhotos)}
      </div>
    );
  };

  const RenderPencilIcon = (displayId) => {
    if (
      !hoveredItem ||
      hoveredItem?.displayId !== displayId ||
      confirmPhotoDelete ||
      !isHovered
    )
      return null;

    return (
      <button
        type="button"
        className="pencil-icon"
        onClick={() => {
          handlePencilClick(displayId);
          setEditItem(displayId);
        }}
      >
        {!confirmPhotoDelete && <i className="bi bi-pencil-fill"></i>}
      </button>
    );
  };

  const RenderShowDropdown = (photoItem) => {
    if (!isDropdownVisible || hoveredItem?.displayId !== photoItem?.displayId)
      return null;

    return (
      <div className="img-update-deletedropdown" ref={dropDownRef}>
        <div className="dropdown-menu show">
          <button
            className="dropdown-item dropdown-item-divider photosListDropdownItem"
            onClick={() => {
              setEditPhotoPopup(!editPhotoPopup);
              dispatch(fetchPracticeProvidersName(practiceId));
              setEditingPhotoItem(photoItem);
            }}
          >
            Edit Photo
          </button>
          <button
            className="dropdown-item dropdown-item-divider photosListDropdownItem"
            onClick={() => {
              setConfirmPhotoDelete(!confirmPhotoDelete);
              setIsDropdownVisible(!isDropdownVisible);
              setDeleteLocation("current");
              // handleOnDeletePhoto(displayId);
            }}
          >
            Delete From This Location
          </button>
          <button
            className="dropdown-item photosListDropdownItem"
            onClick={() => {
              setConfirmPhotoDelete(!confirmPhotoDelete);
              setIsDropdownVisible(!isDropdownVisible);
              setDeleteLocation("all");
            }}
          >
            Delete From All Location
          </button>
        </div>
      </div>
    );
  };

  const RenderConfirmPhotoDeleteModal = () => {
    return (
      <div
        className="confirmDeleteBtnWrapper"
        style={{
          height: "140px",
          width: "210px",
          color: "#ffffff",
          fontSize: "16px",
          fontWeight: 400,
          marginBottom: "15px",
          right: "1px",
        }}
      >
        <div className="confirmText" style={{ opacity: 1 }}>
          Delete Photo ?
        </div>
        <div style={{ display: "flex" }}>
          <div
            className="yesBt"
            onClick={() => {
              // handleProviderPhotoDelete();
              handleOnDeletePhoto();
            }}
          >
            YES
          </div>
          <div
            className="noBtn"
            onClick={() => {
              setConfirmPhotoDelete(!confirmPhotoDelete);
              setEditItem(null);
            }}
          >
            NO
          </div>
        </div>
      </div>
    );
  };

  const RenderPhotosList = () => {
    if (isPracticePhotosLoading) return <div> Loading ... </div>;

    if (practicePhotosData.length < 1) {
      return (
        <div className="noDataInformationWrapper">
          No photos uploaded for this practice
        </div>
      );
    }

    return (
      <div className="practiceAllPhotosListWrapper">
        {practicePhotosData.map((photosItem, index) => (
          <div
            className="photosImg position-relative d-inline-block"
            onMouseEnter={() => {
              handleMouseEnter(photosItem);
            }}
            onMouseLeave={() => {
              handleMouseLeave(photosItem);
            }}
            key={index}
          >
            <img
              alt=""
              width="193px"
              height="128px"
              src={photosItem?.image?.medium}
              className="photoImage"
              style={{ objectFit: "contain" }}
            />
            {RenderPencilIcon(photosItem.displayId)}
            {RenderShowDropdown(photosItem)}
            {photosItem.displayId === editItem
              ? confirmPhotoDelete && RenderConfirmPhotoDeleteModal()
              : ""}
          </div>
        ))}
      </div>
    );
  };

  const RenderOnlyPopupContent = () => {
    if (isPracticePhotosLoading) return <div> Loading ... </div>;
    // if (practicePhotosData.length < 1) return <div> empty</div>;
    return (
      <div className="yourPhotosWrapper">
        <div>
          <div className="yourPhotos">Your Photos</div>
          <div className="yourPhotosDesc">
            Highlight your practice and attract new patients with great photos.
          </div>
        </div>
        <div>
          <div className="newPhotosWrapper">
            <div className="onlyPracticePhotosContent">
              <div className="onlyPopupFirstBlock">
                {RenderOnlyPopupPracticePhotosHeader()}
                {RenderPhotosList()}
              </div>
            </div>
            <div className="onlyPracticePhotosTips">{RenderPhotoTips()}</div>
          </div>
        </div>
      </div>
    );
  };

  const RenderErrors = () => {
    if (!showError) return null;
    return (
      <div className="alert alert-danger" role="alert">
        Something went wrong. Please check and try again.
      </div>
    );
  };

  return (
    <div className="PracticePhotosWrapper">
      {RenderErrors()}
      <div className="successErrorMsg">
        {showMsg && (
          <div className="alert alert-success alertTopPosition" role="alert">
            {showMsg}
          </div>
        )}
      </div>
      {!onlyPopup && (
        <div className="practicePhotosContent">
          {RenderPracticePhotosHeader()}
          {RenderPhotosList()}
          {RenderPhotosPopupOne()}
          {RenderPhotosPopupTwo()}
          {RenderEditPhotoPopup()}
        </div>
      )}
      {onlyPopup && (
        <PopupModal
          onClose={() => {
            closePhotosPopupCallback();
          }}
          isOpen={onlyPhotosPopup}
          customRender={RenderOnlyPopupContent}
        />
      )}
      {onlyPopup && (
        <>
          {RenderPhotosPopupOne()}
          {RenderPhotosPopupTwo()}
          {RenderEditPhotoPopup()}
        </>
      )}
      {!onlyPopup && (
        <div className="practicePhotosTips">{RenderPhotoTips()}</div>
      )}
    </div>
  );
};
export default PracticePhotos;
